import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { NgComponentOutlet } from '@angular/common';
import { LucideChevronRight } from '@lucide/angular';

export interface BreadcrumbItem {
  id: string;
  label: string;
}

@Component({
  selector: 'ds-breadcrumb',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgComponentOutlet],
  template: `
    <nav [attr.aria-label]="ariaLabel()">
      <ol class="crumbs">
        @for (item of items(); track item.id; let last = $last) {
          <li class="crumbs__item">
            @if (!last) {
              <button type="button" class="crumbs__link" (click)="itemSelected.emit(item.id)">
                {{ item.label }}
              </button>
              <span class="crumbs__sep" aria-hidden="true">
                <ng-container
                  [ngComponentOutlet]="separator"
                  [ngComponentOutletInputs]="{ size: 18, strokeWidth: 2.25 }"
                />
              </span>
            } @else {
              <span class="crumbs__current" aria-current="page">{{ item.label }}</span>
            }
          </li>
        }
      </ol>
    </nav>
  `,
  styles: `
    :host { display: block; }

    nav { max-width: 640px; margin: 0 auto; }

    .crumbs {
      list-style: none;
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      margin: 0;
      padding: 0;
    }

    .crumbs__item {
      display: inline-flex;
      align-items: center;
    }

    .crumbs__link {
      min-height: var(--touch-target);
      padding: 0 var(--space-2);
      border: 0;
      border-radius: var(--radius-sm);
      background: transparent;
      color: var(--color-primary);
      font-size: var(--text-sm);
      text-decoration: underline;
      text-underline-offset: 3px;
      cursor: pointer;
      transition: background-color var(--motion-fast);

      &:hover {
        background: var(--color-primary-tint);
      }
    }

    .crumbs__sep {
      display: inline-flex;
      margin: 0 var(--space-1);
      color: var(--color-text-secondary);
    }

    .crumbs__current {
      padding: 0 var(--space-2);
      font-size: var(--text-sm);
      font-weight: var(--font-weight-bold);
      color: var(--color-text);
    }
  `,
})
export class BreadcrumbComponent {
  items = input.required<BreadcrumbItem[]>();
  ariaLabel = input('Jejak halaman');
  itemSelected = output<string>();

  protected readonly separator = LucideChevronRight;
}
